/**
 * «פעילויות ברק» on the customer card — the activities of the previous system «ברק» (activity_barak_c,
 * loaded by backend/scripts/barak_activity_import.py from Salesforce's archived Events).
 *
 * The related endpoint returns at most `limit` rows in no order, so this sorts by the activity's own date
 * (not the 2024 migration date) and says when the customer has more; the full list is in «היסטוריית לקוח».
 */
import React from 'react';

const MUTED = '#706e6b';

/** 'YYYY-MM-DD HH:MM:SS' (UTC, as Salesforce exports it) → Israel date and time. */
export function barakWhen(rec) {
  const raw = rec.Activity_Date_Time__c || rec.Activity_Date__c || '';
  if (!raw) return { key: '', text: '' };
  const iso = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(raw) ? `${raw.replace(' ', 'T')}Z` : raw;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return { key: raw, text: raw };
  const dateOnly = !rec.Activity_Date_Time__c;
  return {
    key: d.toISOString(),
    text: d.toLocaleString('he-IL', dateOnly
      ? { timeZone: 'Asia/Jerusalem', day: 'numeric', month: 'numeric', year: 'numeric' }
      : { timeZone: 'Asia/Jerusalem', day: 'numeric', month: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' }),
  };
}

export function sortBarak(records) {
  return [...(records || [])]
    .filter(r => String(r.IsDeleted || '0') !== '1')
    .map(r => ({ r, w: barakWhen(r) }))
    .sort((a, b) => b.w.key.localeCompare(a.w.key));
}

const Row = ({ label, children }) => (children
  ? <div><span style={{ color: MUTED, fontWeight: 500 }}>{label}:</span> <span>{children}</span></div>
  : null);

export default function BarakActivitiesList({ records, total, shown = 20 }) {
  const all = sortBarak(records);
  if (!all.length) return <div style={{ padding: '10px 14px', color: MUTED, direction: 'rtl' }}>אין פעילויות ממערכת ברק</div>;
  const more = Math.max(total || 0, all.length) - Math.min(shown, all.length);
  return (
    <div data-testid="barak-activities" style={{ direction: 'rtl', fontSize: 13, lineHeight: 1.7 }}>
      {all.slice(0, shown).map(({ r, w }, i) => (
        <div key={r.Id || i} data-testid="barak-activity" style={{ padding: '10px 14px', borderBottom: '1px solid #e5e5e5' }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2px 10px', alignItems: 'baseline' }}>
            <b>{r.Barak_activty_type__c || r.Subject__c || 'פעילות'}</b>
            <span style={{ color: MUTED }}>{w.text}</span>
            {r.Name && <span style={{ color: MUTED, fontSize: 12 }}>רשומה {r.Name}</span>}
          </div>
          <Row label="בעלים">{r.Barak_Owner__c}</Row>
          <Row label="סגר">{r.Barak_Closing_Employee__c}</Row>
          <Row label="מכשיר">{r.Barak_Device_Name__c}</Row>
          <Row label="פילטרים">{r.Barak_Type_Of_Filters__c}</Row>
          <Row label="נושא">{r.Barak_activty_type__c ? r.Subject__c : null}</Row>
          <Row label="תיאור">{[r.Description__c, r.Desctiption__c].filter(Boolean).join(' · ')}</Row>
          <Row label="פעולה שבוצעה">{r.Action_Taken__c}</Row>
          <Row label="תוצאה">{r.Activity_Outcome__c}</Row>
          <Row label="פרטים נוספים">{r.More_details__c}</Row>
        </div>
      ))}
      {more > 0 && (
        <div style={{ padding: '8px 14px', color: MUTED }}>
          ועוד {more} פעילויות — כולן בדשבורד מוצרים וחשבונות ← היסטוריית לקוח
        </div>
      )}
    </div>
  );
}
